//Libraries
import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';

// component
import HomePageAPI from 'shared/layouts/Homepage/HomePageAPI';
import Child from './Child';
import Placeholder from './Placeholder';

// constants
import { fallbackConfig } from 'shared/layouts/Homepage/constants';

// redux
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

interface IHomepageDesktopProps {
  pageName: string;
}

function HomepageDesktop({ pageName }: IHomepageDesktopProps) {
  return (
    <HomePageAPI pageName={pageName} placeholder={<Placeholder />}>
      {Child}
    </HomePageAPI>
  );
}

const mapStateToProps = (state: any) => {
  let config = {};
  try {
    config = JSON.parse(getRemoteConfig(state, 'ad_platform_pages'));
  } catch (err) {
    config = fallbackConfig;
  }

  return {
    pageName: get(config, 'homePageDesktop'),
  };
};

export default connect(mapStateToProps)(HomepageDesktop);
